import { Autocomplete, AutocompleteOption } from '@healthinal/ui';
import { UserDto } from '../../api/generated/model';
import { useUsers } from '../../api/created/users.ts';

interface Props {
  onChange: (userDto: UserDto | null) => void;
  value: UserDto | null;
  disabled?: boolean;
}
export function SelectUser({ onChange, value, disabled }: Props) {
  const { data: users, isPending } = useUsers();

  return (
    <Autocomplete
      value={value}
      disabled={disabled}
      onChange={(_, value) => onChange(value)}
      loading={isPending}
      options={users ?? []}
      getOptionLabel={(option) => option.lastName + ' ' + option.firstName}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderOption={(props, option) => (
        <AutocompleteOption {...props} key={option.id}>
          {option.lastName} {option.firstName}
        </AutocompleteOption>
      )}
    />
  );
}
